import React from 'react';
import { usePage, Link, router } from '@inertiajs/react';
import { ArrowLeft, Send, CheckCircle, Clock, AlertTriangle } from 'lucide-react';

export default function Preview() {
  const { invitation, stats, paginatedUsers, personalizedPreviews, locale } = usePage<any>().props;

  const handleSend = () => {
    if (confirm('Are you sure you want to queue these invitations for sending?')) {
      router.post(`/${locale || 'en'}/invitations/${invitation.id}/send_invitations`);
    }
  };

  return (
    <div className="max-w-screen-xl mx-auto py-10 px-4 md:px-8">
      <div className="mb-6 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link href={`/invitations/${invitation.id}/manage_users`} className="text-gray-400 hover:text-gray-600">
            <ArrowLeft className="h-6 w-6" />
          </Link>
          <h1 className="text-2xl font-bold text-gray-800">Preview Campaign: {invitation.name}</h1>
        </div>
        <button
          onClick={handleSend}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 rounded shadow-sm transition"
        >
          <Send className="h-4 w-4" /> Start Sending
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
        <div className="bg-white p-4 rounded-lg shadow border border-gray-100 flex items-center gap-4">
          <div className="p-3 bg-blue-100 text-blue-600 rounded-full">
            <Clock className="w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-gray-500 font-medium">Total Users</p>
            <p className="text-2xl font-bold text-gray-800">{stats.total_users}</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow border border-gray-100 flex items-center gap-4">
          <div className="p-3 bg-green-100 text-green-600 rounded-full">
            <CheckCircle className="w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-gray-500 font-medium">Sent</p>
            <p className="text-2xl font-bold text-gray-800">{stats.sent_count}</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow border border-gray-100 flex items-center gap-4 col-span-2">
          <div className="p-3 bg-indigo-100 text-indigo-600 rounded-full w-full max-w-[48px]">
             <AlertTriangle className="w-6 h-6" />
          </div>
          <div className="flex-1 w-full relative pt-1">
             <div className="flex mb-2 items-center justify-between border-gray-800">
                <div>
                  <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-indigo-600 bg-indigo-200">
                    Sending Progress
                  </span>
                </div>
                <div className="text-right">
                  <span className="text-xs font-semibold inline-block text-indigo-600">
                    {stats.progress}%
                  </span>
                </div>
              </div>
              <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-indigo-200">
                <div style={{ width: `${stats.progress}%` }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-indigo-500"></div>
              </div>
          </div>
        </div>
      </div>

      <div className="bg-white shadow sm:rounded-lg p-6 border border-gray-100">
        <h3 className="text-xl font-bold text-gray-800 mb-6">WhatsApp Template Samples</h3>
        {personalizedPreviews && personalizedPreviews.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
             {personalizedPreviews.map((preview: any, index: number) => (
               <div key={index} className="border border-gray-200 rounded-lg overflow-hidden bg-gray-50">
                 <div className="bg-gray-100 p-3 border-b border-gray-200 font-medium text-sm text-gray-700">
                    Preview for: {paginatedUsers[index]?.name}
                 </div>
                 <div className="p-4 bg-[url('/whatsapp-bg.png')] bg-cover min-h-[150px]">
                    <div className="bg-white rounded-lg shadow-sm p-4 max-w-[85%] relative border border-gray-100">
                       <p className="whitespace-pre-wrap text-sm text-gray-800">
                         {preview?.whatsapp?.body_text || "No whatsapp body preview available"}
                       </p>
                    </div>
                 </div>
               </div>
             ))}
          </div>
        ) : (
          <div className="text-center py-10 bg-gray-50 rounded-lg border border-gray-200 border-dashed">
            <p className="text-gray-500">No previews automatically generated. Ensure users exist and templates are approved.</p>
          </div>
        )}
      </div>
    </div>
  );
}
